//---------------------------------------------------
//  Nom du fichier : LinkedList.js 
//
//  Description: Fichier qui contient la class LinkedList et Node
//               pour avoir notre propre Structure de donnée
//               Utiliser dans la page rencontre pour garder les profils
//
//  Auteur: Alek Del Balso
//---------------------------------------------------

export class LinkedListe{   
    constructor(){
        this.head = null
    }

    is_empty(){
        return this.head == null
    }

    delete(){
        this.head = null
    }

    insertion_debut(node){
        node.suivant = this.head
        this.head = node
    }

    insertion_fin(node){
        if(this.head == null){
            this.head = node
        }
        else {
            this.insertion_fin_rec(this.head, node)
        }
    }

    insertion_fin_rec(next, node){
        if(next.suivant == null){
            next.suivant = node
        }
        else{
            this.insertion_fin_rec(next.suivant, node)
        }
    }

    supression_debut(){
        this.head = this.head.suivant
    }

    get(nb){
        if(this.head != null){
            let courant = this.head
            for(let i = 0; i < nb;i++){
                courant = courant.suivant
            }
            return courant.value
        }
        return null
    }
}


export class Node{
    constructor(value){
        this.suivant = null
        this.value = value
    }
}

